import React, { useState, useEffect } from 'react';
import { Send, Twitter, Youtube, Play, TrendingUp, Users, Award, BarChart3, Zap, Star, ArrowRight, Instagram } from 'lucide-react';

const TraderPortfolio = () => {
  const [activeVideo, setActiveVideo] = useState(0);
  const [isVisible, setIsVisible] = useState({});
  const [cryptoPrices, setCryptoPrices] = useState({});
  const [loading, setLoading] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Your profile information - Update these with your details
  const profileInfo = {
    name: "Trade with Murtaza", // Replace with your name
    title: "Trade with Murtaza",
    image: "/profile.jpg", // Replace with your photo URL
    experience: "5+ Years",
    successRate: "99%"
  };

  // Mock data for your content - replace with your actual data
  const socialLinks = {
    whatsapp: "https://whatsapp.com/channel/0029Vad6a5HBA1evEJPNK726", // Replace with your WhatsApp link
    telegram: "https://t.me/tradewithmurtaza", // Replace with your Telegram channel
    twitter: "https://x.com/tradwithmurtaza?s=21", // Replace with your Twitter
    instagram: "https://www.instagram.com/tradewithmurtaza/", // Replace with your Instagram
    youtube: "https://www.youtube.com/@tradewithmurtaza", // Replace with your YouTube channel
    tiktok: "https://www.tiktok.com/@trade_with_murtaza?_t=8mMBWDvyJgc&_r=1", // Replace with your TikTok handle
    assistantWhatsapp: "https://wa.me/923282306260", // Assistant WhatsApp contact
    forex: "https://whatsapp.com/channel/0029Vb7ABieHbFVDSrRMBV01"
  };

  // Exchange and contact information
  const exchangeInfo = {
    referralLink: "https://blofin.com/invite/Murtaza",
    exchangeName: "BloFin",
    assistantContact: "+923282306260"
  };

  const videoPlaylist = [
    { 
      id: "f_mGcrCPWmY", // Replace with your YouTube video IDs
      title: "How Experts Use SL, TP & DCA - The Real Strategy Behind Smart Trading",
      duration: "15:19"
    },
    { 
      id: "yoGPylVu9eM", 
      title: "What are alternative coins? Memecoins, Utility Coins & Types of Crypto Explained",
      duration: "10:17"
    },
    { 
      id: "OhsYRnJAcE0", 
      title: "How to start | Crypto Trading 2025",
      duration: "12:17"
    },
    { 
      id: "0gGJ7-4xf98", 
      title: "Custodial V/S Non Custodial | Crypto Wallet & Which is Best For Your Crypto?",
      duration: "16:27"
    }
  ];

  const stats = [
    { icon: Users, value: "25K+", label: "Community Members" },
    { icon: TrendingUp, value: "99%", label: "Success Rate" },
    { icon: Award, value: "5+", label: "Years Experience" },
    { icon: BarChart3, value: "10K+", label: "Successful Trades" }
  ];


  // TikTok SVG Icon Component
  const TikTokIcon = ({ className = "w-6 h-6" }) => (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor">
      <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-.88-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
    </svg>
  );
  
  // WhatsApp SVG Icon Component
  const WhatsAppIcon = ({ className = "w-6 h-6" }) => (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.570-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.893 3.686z"/>
    </svg>
  );

  // Fetch live crypto prices
  useEffect(() => {
    const fetchCryptoPrices = async () => {
      try {
        const response = await fetch('https://api.coingecko.com/api/v3/simple/price?ids=bitcoin,ethereum,solana,binancecoin,cardano,ripple&vs_currencies=usd&include_24hr_change=true');
        const data = await response.json();
        setCryptoPrices(data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching crypto prices:', error);
        setLoading(false);
      }
    };

    fetchCryptoPrices();
    const interval = setInterval(fetchCryptoPrices, 60000); // Update every minute

    return () => clearInterval(interval);
  }, []);

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(price);
  };

  const formatPercentage = (change) => {
    return `${change >= 0 ? '+' : ''}${change.toFixed(2)}%`;
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setIsVisible(prev => ({
            ...prev,
            [entry.target.id]: entry.isIntersecting
          }));
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('[data-animate]');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 text-white">
      {/* Navigation */}
      <nav className="fixed top-0 w-full z-50 bg-black/20 backdrop-blur-lg border-b border-purple-500/20">
        <div className="max-w-6xl mx-auto px-6 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-3 flex-1 md:flex-initial">
            <img 
              src={profileInfo.image} 
              alt={profileInfo.name}
              className="w-10 h-10 rounded-full border-2 border-purple-500/50"
            />
            <div className="text-xl md:text-2xl font-bold bg-gradient-to-r from-purple-400 to-cyan-400 bg-clip-text text-transparent">
              Trade with Murtaza
            </div>
          </div>
          
          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-6">
            <a href="#home" className="hover:text-purple-400 transition-colors">Home</a>
            <a href="#about" className="hover:text-purple-400 transition-colors">About</a>
            <a href="#get-started" className="hover:text-purple-400 transition-colors">Get Started</a>
            <a href="#courses" className="hover:text-purple-400 transition-colors">Courses</a>
            <a href="#channels" className="hover:text-purple-400 transition-colors">Channels</a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden p-2 rounded-lg border border-purple-500/30 bg-purple-500/10"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {/* Mobile Menu Dropdown */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-black/90 backdrop-blur-lg border-t border-purple-500/20">
            <div className="px-6 py-4 space-y-3">
              <a 
                href="#home" 
                className="block py-2 hover:text-purple-400 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Home
              </a>
              <a 
                href="#about" 
                className="block py-2 hover:text-purple-400 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                About
              </a>
              <a 
                href="#get-started" 
                className="block py-2 hover:text-purple-400 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Get Started
              </a>
              <a 
                href="#courses" 
                className="block py-2 hover:text-purple-400 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Courses
              </a>
              <a 
                href="#channels" 
                className="block py-2 hover:text-purple-400 transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                Channels
              </a>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section - Fits within 100vh */}
      {/* Hero Section - Fits within 100vh */}
      <section id="home" className="min-h-screen flex items-center justify-center pt-20 px-6">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-8 items-center">
          <div className="space-y-6">
            <div className="space-y-4">
              <h1 className="text-4xl lg:text-6xl font-bold leading-tight">
                Master
                <span className="bg-gradient-to-r from-purple-400 to-cyan-400 bg-clip-text text-transparent">
                  {" "}Crypto Trading
                </span>
              </h1>
              <p className="text-lg text-gray-300 leading-relaxed">
                Join thousands of successful traders in our exclusive WhatsApp community. 
                Get real-time signals, market analysis, and expert guidance.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href={socialLinks.whatsapp}
                className="group bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 px-6 py-3 rounded-full font-semibold transition-all transform hover:scale-105 flex items-center justify-center space-x-3 shadow-lg shadow-green-500/25"
              >
                <WhatsAppIcon className="w-5 h-5" />
                <span>Join Free Crypto Channel</span>
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
             <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href={socialLinks.forex}
                className="group bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 px-6 py-3 rounded-full font-semibold transition-all transform hover:scale-105 flex items-center justify-center space-x-3 shadow-lg shadow-green-500/25"
              >
                <WhatsAppIcon className="w-5 h-5" />
                <span>Join Free Forex Channel</span>
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </a>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
              {stats.map((stat, index) => (
                <div key={index} className="text-center space-y-2">
                  <stat.icon className="w-6 h-6 mx-auto text-purple-400" />
                  <div className="text-lg font-bold">{stat.value}</div>
                  <div className="text-xs text-gray-400">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative flex items-center">
            <div className="relative z-10 bg-gradient-to-br from-purple-500/20 to-cyan-500/20 backdrop-blur-lg border border-purple-500/30 rounded-3xl p-4 md:p-6 shadow-2xl w-full max-h-[70vh] md:max-h-none overflow-hidden">
              <div className="flex items-center space-x-3 mb-4">
                <WhatsAppIcon className="w-6 h-6 text-green-400" />
                <div>
                  <h3 className="text-lg font-semibold">Live Crypto Prices</h3>
                  <p className="text-gray-400 text-sm">Real-time prices • Updated every minute</p>
                </div>
              </div>
              
              {loading ? (
                <div className="text-center py-8">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-500 mx-auto mb-2"></div>
                  <p className="text-gray-400">Loading market data...</p>
                </div>
              ) : (
                <div className="space-y-4">
                  {/* Crypto Price Table */}
                  <div className="bg-black/40 rounded-lg overflow-hidden max-h-[50vh] md:max-h-none overflow-y-auto">
                    <div className="grid grid-cols-3 gap-2 p-3 border-b border-gray-700 text-xs text-gray-400 font-medium sticky top-0 bg-black/60 backdrop-blur">
                      <div>Coin</div>
                      <div className="text-right">Price</div>
                      <div className="text-right">24h</div>
                    </div>
                    
                    {Object.entries(cryptoPrices).map(([coinId, data], index) => {
                      const coinInfo = {
                        bitcoin: { name: 'Bitcoin', symbol: 'BTC', logo: '₿' },
                        ethereum: { name: 'Ethereum', symbol: 'ETH', logo: 'Ξ' },
                        solana: { name: 'Solana', symbol: 'SOL', logo: '◎' },
                        binancecoin: { name: 'BNB', symbol: 'BNB', logo: '⬡' },
                        cardano: { name: 'Cardano', symbol: 'ADA', logo: '₳' },
                        ripple: { name: 'XRP', symbol: 'XRP', logo: '✕' }
                      }[coinId] || { name: coinId, symbol: coinId.toUpperCase(), logo: '◉' };

                      return (
                        <div key={coinId} className="grid grid-cols-3 gap-2 p-2 md:p-3 hover:bg-gray-800/50 transition-colors">
                          <div className="flex items-center space-x-1 md:space-x-2">
                            <span className="text-yellow-400 font-bold text-xs md:text-sm">{index + 1}</span>
                            <span className="text-gray-300 text-sm md:text-lg">{coinInfo.logo}</span>
                            <div>
                              <div className="font-medium text-xs md:text-sm">{coinInfo.name}</div>
                              <div className="text-xs text-gray-400 hidden md:block">{coinInfo.symbol}</div>
                            </div>
                          </div>
                          
                          <div className="text-right">
                            <div className="font-semibold text-xs md:text-base">{formatPrice(data.usd)}</div>
                          </div>
                          
                          <div className="text-right">
                            <span className={`font-medium text-xs md:text-sm ${data.usd_24h_change >= 0 ? 'text-green-400' : 'text-red-400'}`}>
                              {formatPercentage(data.usd_24h_change)}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              <div className="mt-4 pt-4 border-t border-gray-600">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-400">Market Status</span>
                  <div className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                    <span className="text-green-400 font-semibold text-sm">Live</span>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Decorative elements */}
            <div className="absolute -top-4 -right-4 w-64 h-64 bg-purple-500/30 rounded-full blur-3xl opacity-50"></div>
            <div className="absolute -bottom-4 -left-4 w-64 h-64 bg-cyan-500/30 rounded-full blur-3xl opacity-50"></div>
          </div>
        </div>
      </section>

       {/* Social Channels Section */}
      <section id="channels" className="py-20 px-6" data-animate>
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6">
              Connect With Us
              <span className="bg-gradient-to-r from-purple-400 to-cyan-400 bg-clip-text text-transparent">
                {" "}Everywhere
              </span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Follow us across all platforms for the latest market updates, 
              trading tips, and community discussions.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
            {[
              
              {
                name: "WhatsApp Crypto",
                icon: WhatsAppIcon,
                color: "from-green-500 to-green-600",
                hoverColor: "hover:from-green-600 hover:to-green-700",
                description: "Free Crypto Signals & Market Updates",
                link: socialLinks.whatsapp
              },
              {
                name: "WhatsApp Forex",
                icon: WhatsAppIcon,
                color: "from-green-500 to-green-600",
                hoverColor: "hover:from-green-600 hover:to-green-700",
                description: "Free Forex Signals & Market Updates",
                link: socialLinks.forex
              },
              {
                name: "Telegram",
                icon: Send,
                color: "from-blue-500 to-blue-600",
                hoverColor: "hover:from-blue-600 hover:to-blue-700",
                description: "Market Updates & Announcements",
                link: socialLinks.telegram
              },
              {
                name: "YouTube",
                icon: Youtube,
                color: "from-red-500 to-red-600",
                hoverColor: "hover:from-red-600 hover:to-red-700",
                description: "Free Courses & Tutorials",
                link: socialLinks.youtube
              },
              {
                name: "Instagram",
                icon: Instagram,
                color: "from-pink-500 to-purple-600",
                hoverColor: "hover:from-pink-600 hover:to-purple-700",
                description: "Trading Tips & Lifestyle Content",
                link: socialLinks.instagram
              },
              
              {
                name: "TikTok",
                icon: TikTokIcon,
                color: "from-black-600 to-purple-700",
                hoverColor: "hover:from-purple-700 hover:to-black-800",
                description: "Quick Trading Tips & Trends",
                link: socialLinks.tiktok
              },
              {
                name: "Twitter",
                icon: Twitter,
                color: "from-sky-500 to-sky-600",
                hoverColor: "hover:from-sky-600 hover:to-sky-700",
                description: "Daily Insights & Market Analysis",
                link: socialLinks.twitter
              }
              
            ].map((channel, index) => (
              <a
                key={index}
                href={channel.link}
                className={`group block bg-gradient-to-br ${channel.color} ${channel.hoverColor} p-6 rounded-2xl transition-all transform hover:scale-105 shadow-lg`}
              >
                <div className="flex items-center justify-between mb-4">
                  <channel.icon className="w-10 h-10 text-white" />
                  <Star className="w-5 h-5 text-white/70" />
                </div>
                <h3 className="text-xl font-bold mb-2">{channel.name}</h3>
                <p className="text-white/90 text-sm mb-3">{channel.description}</p>
                <div className="text-white/80 text-xs font-medium">{channel.members}</div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* How to Start Crypto Trading Section */}
      <section id="get-started" className="py-20 px-6 bg-gradient-to-br from-slate-800/30 to-purple-900/30" data-animate>
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6">
              How to Start
              <span className="bg-gradient-to-r from-purple-400 to-cyan-400 bg-clip-text text-transparent">
                {" "}Crypto Trading
              </span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Follow these simple steps to begin your crypto trading journey with our recommended platform and expert guidance.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Steps */}
            <div className="space-y-6">
              {[
                {
                  step: "01",
                  title: "Sign Up on BloFin Exchange",
                  description: "Create your account using our exclusive referral link to get special benefits and lower trading fees.",
                  action: "Sign Up Now",
                  actionType: "exchange"
                },
                {
                  step: "02",
                  title: "Fund Your Account",
                  description: "Deposit funds via bank transfer, credit card, or cryptocurrency to start your trading journey.",
                  action: "Deposit Guide",
                  actionType: "info"
                },
                {
                  step: "03",
                  title: "Contact Our Assistant",
                  description: "Get personalized guidance and free trading signals from our experienced trading assistant.",
                  action: "Contact Assistant",
                  actionType: "assistant"
                },
                {
                  step: "04",
                  title: "Start Trading",
                  description: "Begin trading with confidence using our signals, analysis, and community support.",
                  action: "Join Community",
                  actionType: "community"
                }
              ].map((item, index) => (
                <div key={index} className="flex items-start space-x-6 group">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-cyan-500 rounded-2xl flex items-center justify-center text-white font-bold text-lg shadow-lg">
                      {item.step}
                    </div>
                  </div>
                  <div className="flex-1 space-y-3">
                    <h3 className="text-xl font-semibold group-hover:text-purple-400 transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-gray-400 leading-relaxed">
                      {item.description}
                    </p>
                    <div>
                      {item.actionType === 'exchange' && (
                        <a
                          href={exchangeInfo.referralLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center space-x-2 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 px-4 py-2 rounded-lg font-medium transition-all transform hover:scale-105 text-sm"
                        >
                          <span>{item.action}</span>
                          <ArrowRight className="w-4 h-4" />
                        </a>
                      )}
                      {item.actionType === 'assistant' && (
                        <a
                          href={socialLinks.assistantWhatsapp}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center space-x-2 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 px-4 py-2 rounded-lg font-medium transition-all transform hover:scale-105 text-sm"
                        >
                          <WhatsAppIcon className="w-4 h-4" />
                          <span>{item.action}</span>
                          <ArrowRight className="w-4 h-4" />
                        </a>
                      )}
                      {item.actionType === 'community' && (
                        <a
                          href={socialLinks.whatsapp}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center space-x-2 bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 px-4 py-2 rounded-lg font-medium transition-all transform hover:scale-105 text-sm"
                        >
                          <Users className="w-4 h-4" />
                          <span>{item.action}</span>
                          <ArrowRight className="w-4 h-4" />
                        </a>
                      )}
                      {item.actionType === 'info' && (
                        <span className="text-purple-400 font-medium text-sm cursor-pointer hover:text-purple-300 transition-colors">
                          {item.action} →
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Right Side - Contact Card */}
            <div className="relative">
              <div className="bg-gradient-to-br from-purple-500/20 to-cyan-500/20 backdrop-blur-lg border border-purple-500/30 rounded-3xl p-8 shadow-2xl">
                <div className="text-center space-y-6">
                  <div className="w-20 h-20 mx-auto bg-gradient-to-br from-green-500 to-emerald-600 rounded-full flex items-center justify-center shadow-lg">
                    <WhatsAppIcon className="w-10 h-10 text-white" />
                  </div>
                  
                  <div>
                    <h3 className="text-2xl font-bold mb-2">Personal Trading Assistant</h3>
                    <p className="text-gray-400">Get 1-on-1 guidance and support</p>
                  </div>

                  <div className="space-y-4">
                    <div className="bg-black/40 rounded-lg p-4">
                      <div className="text-sm text-gray-400 mb-1">WhatsApp Contact</div>
                      <div className="font-mono text-lg text-green-400">{exchangeInfo.assistantContact}</div>
                    </div>
                    
                    <div className="bg-black/40 rounded-lg p-4">
                      <div className="text-sm text-gray-400 mb-1">Recommended Exchange</div>
                      <div className="font-semibold text-lg text-purple-400">{exchangeInfo.exchangeName}</div>
                    </div>
                  </div>

                  <div className="space-y-3">
                    <a
                      href={socialLinks.assistantWhatsapp}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 px-6 py-3 rounded-full font-semibold transition-all transform hover:scale-105 flex items-center justify-center space-x-3 shadow-lg"
                    >
                      <WhatsAppIcon className="w-5 h-5" />
                      <span>Contact Assistant</span>
                    </a>
                    
                    <a
                      href={exchangeInfo.referralLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full border-2 border-purple-500 hover:bg-purple-500 px-6 py-3 rounded-full font-semibold transition-all flex items-center justify-center space-x-3"
                    >
                      <TrendingUp className="w-5 h-5" />
                      <span>Start Trading on {exchangeInfo.exchangeName}</span>
                    </a>
                  </div>

                  <div className="text-xs text-white-500 space-y-1">
                    <p>• Free consultation available</p>
                    <p>• Personalized trading strategies</p>
                    <p>• 24/7 WhatsApp support</p>
                  </div>
                </div>
              </div>
              
              {/* Decorative elements */}
              <div className="absolute -top-4 -right-4 w-32 h-32 bg-green-500/30 rounded-full blur-2xl opacity-50"></div>
              <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-purple-500/30 rounded-full blur-2xl opacity-50"></div>
            </div>
          </div>

          {/* Bottom CTA 
          <div className="mt-16 text-center">
            <div className="bg-gradient-to-r from-purple-900/50 to-cyan-900/50 rounded-2xl p-8 border border-purple-500/30">
              <h3 className="text-2xl font-bold mb-4">Ready to Start Your Trading Journey?</h3>
              <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
                Join thousands of successful traders who started their journey with our guidance and exclusive exchange partnership.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href={exchangeInfo.referralLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 px-8 py-4 rounded-full font-semibold transition-all transform hover:scale-105 flex items-center justify-center space-x-3 shadow-lg"
                >
                  <TrendingUp className="w-6 h-6" />
                  <span>Sign Up on {exchangeInfo.exchangeName}</span>
                  <ArrowRight className="w-5 h-5" />
                </a>
                <a
                  href={socialLinks.assistantWhatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="border-2 border-green-500 hover:bg-green-500 px-8 py-4 rounded-full font-semibold transition-all flex items-center justify-center space-x-3"
                >
                  <WhatsAppIcon className="w-6 h-6" />
                  <span>Get Personal Guidance</span>
                </a>
              </div>
            </div>
          </div>*/}
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 px-6" data-animate>
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6">
              Why Choose 
              <span className="bg-gradient-to-r from-purple-400 to-cyan-400 bg-clip-text text-transparent">
                {" "}Our Community?
              </span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              We're not just another trading group. We're a community of serious traders 
              committed to consistent profits and risk management.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                icon: Zap,
                title: "Real-Time Signals",
                description: "Get instant notifications for high-probability trades with detailed entry and exit points."
              },
              {
                icon: Users,
                title: "Expert Community",
                description: "Learn from experienced traders and share insights with like-minded professionals."
              },
              {
                icon: BarChart3,
                title: "Proven Results",
                description: "Track record of consistent profits with transparent performance metrics."
              }
            ].map((feature, index) => (
              <div key={index} className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-lg border border-purple-500/20 rounded-2xl p-8 hover:border-purple-500/40 transition-all">
                <feature.icon className="w-12 h-12 text-purple-400 mb-6" />
                <h3 className="text-xl font-semibold mb-4">{feature.title}</h3>
                <p className="text-gray-400 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* YouTube Courses Section */}
      <section id="courses" className="py-20 px-6 bg-black/20" data-animate>
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6">
              Free 
              <span className="bg-gradient-to-r from-purple-400 to-cyan-400 bg-clip-text text-transparent">
                {" "}Crypto Courses
              </span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Master the fundamentals with our comprehensive video course series. 
              From basics to advanced strategies.
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8">
            {/* Main Video Player */}
            <div className="lg:col-span-2">
              <div className="bg-black rounded-2xl overflow-hidden shadow-2xl">
                <div className="aspect-video">
                  <iframe
                    src={`https://www.youtube.com/embed/${videoPlaylist[activeVideo].id}`}
                    title={videoPlaylist[activeVideo].title}
                    className="w-full h-full"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold mb-2">{videoPlaylist[activeVideo].title}</h3>
                  <div className="flex items-center space-x-4 text-gray-400">
                    <span>{videoPlaylist[activeVideo].duration}</span>
                    <span>•</span>
                    <span>Trading Tutorial</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Playlist */}
            <div className="space-y-4">
              <h3 className="text-xl font-semibold mb-4 flex items-center">
                <Youtube className="w-6 h-6 text-red-500 mr-2" />
                Course Playlist
              </h3>
              {videoPlaylist.map((video, index) => (
                <div
                  key={index}
                  onClick={() => setActiveVideo(index)}
                  className={`cursor-pointer rounded-lg p-4 transition-all ${
                    activeVideo === index 
                      ? 'bg-purple-500/20 border border-purple-500/40' 
                      : 'bg-slate-800/50 border border-slate-700/50 hover:border-purple-500/30'
                  }`}
                >
                  <div className="flex items-start space-x-3">
                    <div className="relative">
                      <img 
                        src={`https://img.youtube.com/vi/${video.id}/mqdefault.jpg`}
                        alt={video.title}
                        className="w-20 h-12 object-cover rounded"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                      />
                      <div className="w-20 h-12 bg-slate-700 rounded flex items-center justify-center" style={{display: 'none'}}>
                        <Play className="w-5 h-5 text-white" />
                      </div>
                      <div className="absolute -bottom-1 -right-1 bg-black/80 text-white text-xs px-1 rounded">
                        {video.duration}
                      </div>
                      {activeVideo !== index && (
                        <div className="absolute inset-0 flex items-center justify-center bg-black/40 rounded">
                          <Play className="w-4 h-4 text-white" />
                        </div>
                      )}
                    </div>
                    <div className="flex-1 min-w-0">
                      <h4 className="font-medium text-sm leading-tight mb-1">{video.title}</h4>
                      <p className="text-xs text-gray-400">Trading Tutorial</p>
                    </div>
                  </div>
                </div>
              ))}
              
              <a 
                href={socialLinks.youtube}
                className="block w-full bg-red-600 hover:bg-red-700 text-center py-3 rounded-lg font-semibold transition-colors"
              >
                Subscribe for More
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Add this somewhere in your JSX to use the variable */}
{Object.keys(isVisible).length > 0 && (
  <div style={{ display: 'none' }}>
    {/* This div uses isVisible but doesn't render anything visible */}
    {JSON.stringify(isVisible)}
  </div>
)}

      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-r from-purple-900/50 to-cyan-900/50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            Ready to Start
            <span className="bg-gradient-to-r from-purple-400 to-cyan-400 bg-clip-text text-transparent">
              {" "}Your Trading Journey?
            </span>
          </h2>
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
            Join thousands of successful traders who trust our signals and analysis. 
            Start making profitable trades today.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href={socialLinks.whatsapp}
              className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 px-8 py-4 rounded-full font-semibold transition-all transform hover:scale-105 flex items-center justify-center space-x-3 shadow-lg shadow-green-500/25"
            >
              <WhatsAppIcon className="w-6 h-6" />
              <span>Join Free Whatsapp Channel</span>
            </a>
            <a 
              href={socialLinks.youtube}
              className="border-2 border-red-500 hover:bg-red-500 px-8 py-4 rounded-full font-semibold transition-all flex items-center justify-center space-x-3"
            >
              <Youtube className="w-6 h-6" />
              <span>Watch Free Course</span>
            </a>
          </div>
        </div>
      </section>
{/* Sticky Contact Assistant Button */}
      <div className="fixed bottom-6 right-6 z-50">
        
          <a href={socialLinks.assistantWhatsapp}
          target="_blank" 
          rel="noopener noreferrer"
          className="group bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 p-4 rounded-full shadow-2xl shadow-green-500/40 transition-all transform hover:scale-110 flex items-center space-x-3 animate-pulse hover:animate-none"
        >
          <WhatsAppIcon className="w-6 h-6 text-white" />
          <span className="hidden md:block text-white font-semibold pr-2">Contact Assistant</span>
          <div className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full animate-bounce"></div>
        </a>
      </div>
      {/* Footer */}
      <footer className="bg-black/40 py-12 px-6 border-t border-purple-500/20">
        <div className="max-w-6xl mx-auto text-center">
          <div className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-cyan-400 bg-clip-text text-transparent mb-4">
            Trade with Murtaza
          </div>
          <p className="text-gray-400 mb-6">
            Professional crypto trading signals and education platform
          </p>
          <div className="flex justify-center space-x-6">
            <a href={socialLinks.whatsapp} className="text-green-400 hover:text-green-300 transition-colors">
              <WhatsAppIcon className="w-6 h-6" />
            </a>
            <a href={socialLinks.telegram} className="text-blue-400 hover:text-blue-300 transition-colors">
              <Send className="w-6 h-6" />
            </a>
            <a href={socialLinks.tiktok} className="text-white-400 hover:text-gray-300 transition-colors">
              <TikTokIcon className="w-6 h-6" />
            </a>
             <a href={socialLinks.twitter} className="text-sky-400 hover:text-sky-300 transition-colors">
              <Twitter className="w-6 h-6" />
            </a>
            <a href={socialLinks.instagram} className="text-pink-400 hover:text-pink-300 transition-colors">
              <Instagram className="w-6 h-6" />
            </a>
            <a href={socialLinks.youtube} className="text-red-400 hover:text-red-300 transition-colors">
              <Youtube className="w-6 h-6" />
            </a>
          </div>
          <div className="mt-8 pt-8 border-t border-gray-800 text-gray-500 text-sm">
            © 2025 Trade with Murtaza. All rights reserved. Trading involves risk.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TraderPortfolio;
